import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  label {
    color: #0000ff;
    font-size: 1.75rem;
    font-weight: 600;
    margin: 5px 0;
  }

  input {
    width: 60%;
    padding: 1.5rem;
    border: 1px solid #d2d2d2;
    border-radius: 5px;
    outline: none;
    color: #747474;
    font-size: 1.2rem;

    &::placeholder {
      font-size: 1.75rem;
      color: #d2d2d2;
    }

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  legend {
    color: #333;
    font-size: 1rem;
    font-weight: 700;
    margin-bottom: 10px;
  }
`;
